import type { Field, FieldGroup, FieldIdToValueMap } from "../../api/types/objectTypes";
import type { FieldGroupModel } from "./entityFieldTypes";

export const getVisibleFieldGroupModels = (
  fieldGroups: FieldGroup[],
  forceReadOnly: boolean,
  objectDefinitionFields: Field[]
): FieldGroupModel[] => {
  return fieldGroups
    .filter((g) => g.fields.some((f) => f.isVisible))
    .map((group) => {
      const fields: Field[] = [];

      group.fields
        .filter((f) => f.isVisible)
        .forEach((fieldRef) => {
          const field = objectDefinitionFields.find((f) => f.id === fieldRef.fieldId);
          if (field) {
            const fieldModel = { ...field, attributes: [...field.attributes] };
            if (forceReadOnly && !fieldModel.attributes.includes("ReadOnly")) {
              fieldModel.attributes.push("ReadOnly");
            }
            fields.push(fieldModel);
          }
        });

      return {
        name: group.name,
        fields,
      };
    });
};

export const getUpdatedFieldValues = (
  fieldValues: FieldIdToValueMap,
  value: unknown,
  fieldId: string
): FieldIdToValueMap => {
  if (value === undefined) {
    const existingFieldValue = fieldValues[fieldId];
    if (existingFieldValue) {
      fieldValues[fieldId] = null;
    }
  } else {
    fieldValues[fieldId] = value;
  }

  return fieldValues;
};

export const removeDecimalNotSupportedCharacters = (input: string): string => {
  const digitsAndSeparators = input.replace(/[^\d.,]/g, "");
  return input.trimStart().startsWith("-") ? `-${digitsAndSeparators}` : digitsAndSeparators;
};

const isValueEmpty = (v: unknown) => v === undefined || v === null || v === "" || (Array.isArray(v) && !v.length);

export const isAnyRequiredFieldEmpty = (fields: Field[], fieldValues: FieldIdToValueMap): boolean =>
  fields.filter((f) => f.attributes.includes("Required")).some((f) => isValueEmpty(fieldValues[f.id]));
